import AdminInvoices from "../symbols/getAdminInvoices";
import { HttpRequestPost } from "../../service";
const getAdminInvoicesAction = () => ({
  type: AdminInvoices.ADMIN_INVOICES,
});
const getAdminInvoicesSuccessAction = (data: any) => ({
  type: AdminInvoices.ADMIN_INVOICES_SUCCESS,
  payload: data,
});
const getAdminInvoicesFailureAction = (data: any) => ({
  type: AdminInvoices.ADMIN_INVOICES_FAILURE,
  payload: data,
});
const clearAdminInvoicesAction = () => ({
  type: AdminInvoices.CLEAR_ADMIN_INVOICES,
});
interface GetAdminInvoicesRequestModelFilter {
  DateFrom?: Date;
  DateTo?: Date;
  Merchants?: string[];
  Shops?: string[];
  InvoiceType?: {
    TradeKart?: boolean;
    Shop?: boolean;
    TradeKartFee?: boolean;
    TradeKartCollect?: boolean;
  };

}
interface GetAdminInvoicesRequestModel {
  Query?: string;
  Filter?: GetAdminInvoicesRequestModelFilter;
  Size: number;
  Page: number;

}
export function getAdminInvoices(data: GetAdminInvoicesRequestModel, callback?: (resp?: any) => void) {
  return (dispatch: any) => {
    dispatch(getAdminInvoicesAction());
    HttpRequestPost(
      `/admin/invoice`,
      dispatch,
      getAdminInvoicesSuccessAction,
      getAdminInvoicesFailureAction,
      true,
      data,
      callback
    );
  };
}

export function clearAdminInvoices() {
  return (dispatch: any) => {
    dispatch(clearAdminInvoicesAction());
  };
}
